import styled from "styled-components";
import { ArrowRight } from "@phosphor-icons/react";

import Reveal from "./Shared/Reveal";
import { ButtonLink } from "./Shared/ui";

const JoinUs = () => {
  return (
    <Band>
      <Inner>
        <Reveal>
          <Kicker>So please join us</Kicker>
          <Quote>Together we can achieve our mission.</Quote>
          <Sub>We request your support and help of all nature in carrying out our mission.</Sub>
        </Reveal>
        <Reveal index={1}>
          <ButtonLink href="#contact" $variant="dark">
            Contact <ArrowRight size={18} weight="bold" />
          </ButtonLink>
        </Reveal>
      </Inner>
    </Band>
  );
};

const Band = styled.section`
  padding: 0 var(--gutter);
`;

const Inner = styled.div`
  position: relative;
  overflow: hidden;
  max-width: var(--max-w);
  margin: 0 auto;
  padding: clamp(40px, 6vw, 72px);
  border-radius: 28px;
  background:
    radial-gradient(90% 140% at 100% 100%, rgb(248 233 161 / 0.55) 0%, transparent 55%),
    var(--coral);
  color: var(--on-accent);
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: end;
  gap: 32px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    align-items: start;
  }
`;

const Kicker = styled.p`
  font-family: var(--font-display);
  font-weight: 600;
  font-size: 18px;
  margin-bottom: 8px;
`;

const Quote = styled.h2`
  color: var(--on-accent);
  font-size: clamp(32px, 5vw, 56px);
  letter-spacing: -0.03em;
  max-width: 16ch;
  margin-bottom: 14px;
`;

const Sub = styled.p`
  font-size: 17px;
  max-width: 50ch;
  margin: 0;
`;

export default JoinUs;
